import { render, staticRenderFns } from "./TableCell.vue?vue&type=template&id=4ca5af05&scoped=true"
import script from "./TableCell.vue?vue&type=script&setup=true&lang=js"
export * from "./TableCell.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TableCell.vue?vue&type=style&index=0&id=4ca5af05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca5af05",
  null
  
)

export default component.exports